import { render, staticRenderFns } from "./UserStatusDialog.vue?vue&type=template&id=cf8c675a&scoped=true"
import script from "./UserStatusDialog.vue?vue&type=script&lang=js"
export * from "./UserStatusDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf8c675a",
  null
  
)

export default component.exports